import { MessageService } from '@progress/kendo-angular-l10n';
import * as en from '../../assets/i18n/en.json';
import * as nl from '../../assets/i18n/nl.json';
import * as fr from '../../assets/i18n/fr.json';

const languages: any = { en, nl, fr };

export class KendoMessageService extends MessageService {
    private localeId: string = 'en';
    private messages: Map<string, string>;

    public set language(value: string) {
        this.setMessages(value);
        if (this.messages) {
            this.localeId = value;
            this.notify(false);
        }
    }

    public get language(): string {
        return this.localeId;
    }

    public get(key: string): string {
        return (this.messages && this.messages.has(key)) ? this.messages.get(key) : undefined;
    }

    private setMessages(language: string): any {
        const lang: any = languages[language];
        const gridPrefix: string = 'kendo.grid.';
        this.messages = new Map([
            [gridPrefix + 'filterAfterOperator', lang.KENDO_AFTER],
            [gridPrefix + 'filterAfterOrEqualOperator', lang.KENDO_AFTER_OR_EQUAL],
            [gridPrefix + 'filterBeforeOperator', lang.KENDO_BEFORE],
            [gridPrefix + 'filterBeforeOrEqualOperator', lang.KENDO_BEFORE_OR_EQUAL],
            [gridPrefix + 'filterContainsOperator', lang.KENDO_CONTAINS],
            [gridPrefix + 'filterEndsWithOperator', lang.KENDO_ENDS_WITH],
            [gridPrefix + 'filterEqOperator', lang.KENDO_EQUAL_TO],
            [gridPrefix + 'filterGtOperator', lang.KENDO_GREATER_THAN],
            [gridPrefix + 'filterGteOperator', lang.KENDO_GREATER_THAN_OR_EQUAL],
            [gridPrefix + 'filterLtOperator', lang.KENDO_LESS_THAN],
            [gridPrefix + 'filterLteOperator', lang.KENDO_LESS_THAN_OR_EQUAL],
            [gridPrefix + 'filterNotContainsOperator', lang.KENDO_DOES_NOT_CONTAIN],
            [gridPrefix + 'filterNotEqOperator', lang.KENDO_NOT_EQUAL_TO],
            [gridPrefix + 'filterIsEmptyOperator', lang.KENDO_IS_EMPTY],
            [gridPrefix + 'filterIsNotEmptyOperator', lang.KENDO_IS_NOT_EMPTY],
            [gridPrefix + 'filterIsNotNullOperator', lang.KENDO_IS_NOT_NULL],
            [gridPrefix + 'filterIsNullOperator', lang.KENDO_IS_NULL],
            [gridPrefix + 'filterStartsWithOperator', lang.KENDO_STARTS_WITH],
            [gridPrefix + 'noRecords', lang.KENDO_NO_RECORDS],
            ['kendo.datepicker.today', lang.KENDO_TODAY],
        ]);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/kendo-message.service.ts